<div class="feedback-page">
  <div class="feedback-sheet">
    <!-- Rate step -->
    <div *ngIf="step() === 'rate'" class="feedback-rate-step">
      <header class="feedback-brand">
        <img
          *ngIf="logoUrl()"
          class="feedback-logo"
          [src]="logoUrl()"
          [alt]="carWashName() ? carWashName() + ' logo' : 'Company logo'"
          (error)="onLogoError()"
        />
        <div class="feedback-mark" *ngIf="!logoUrl() && logoInitials()" aria-hidden="true">
          {{ logoInitials() }}
        </div>
      </header>

      <div class="feedback-copy">
        <h1 class="feedback-title">How was your car wash experience?</h1>
        <p class="feedback-subtitle">
          We'd love to hear how we did. Your feedback helps us improve.
        </p>
      </div>

      <div class="star-block">
        <div class="star-row" role="radiogroup" aria-label="Overall experience rating">
          <button
            *ngFor="let star of stars"
            type="button"
            class="star-tile"
            role="radio"
            [attr.aria-label]="star + ' star' + (star === 1 ? '' : 's')"
            [attr.aria-checked]="rating() === star"
            [class.filled]="star <= rating()"
            (click)="pickRating(star)"
          >
            <svg
              class="star-icon"
              width="26"
              height="26"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M12 2.6l2.9 5.9 6.5.95-4.7 4.6 1.1 6.45L12 17.45 6.2 20.5l1.1-6.45-4.7-4.6 6.5-.95z"
              />
            </svg>
          </button>
        </div>
      </div>

      <div class="comment-block" *ngIf="showCommentBox()">
        <label class="comment-label" for="feedback-comment">Tell us what we could do better</label>
        <textarea
          id="feedback-comment"
          class="comment-input"
          name="comment"
          rows="4"
          maxlength="2000"
          [ngModel]="comment()"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onCommentInput($event)"
          placeholder="Share your experience..."
        ></textarea>
        <p class="submit-error" *ngIf="submitError()" role="alert">{{ submitError() }}</p>
      </div>

      <div class="feedback-actions" *ngIf="showContinue()">
        <p class="submit-error action-error" *ngIf="submitError() && !showCommentBox()" role="alert">
          {{ submitError() }}
        </p>
        <button
          type="button"
          class="feedback-continue"
          [disabled]="submitting() || loadingContext()"
          (click)="onSubmit()"
        >
          {{ submitting() ? 'Submitting…' : 'Continue' }}
          <svg
            *ngIf="!submitting()"
            class="continue-arrow"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M5 12h14M13 6l6 6-6 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Thank you -->
    <div class="thanks-block" *ngIf="step() === 'thanks'">
      <div class="thanks-icon" aria-hidden="true">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 6L9 17l-5-5"
            stroke="#079271"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <h2 class="thanks-headline">Thanks for your feedback!</h2>
      <p class="thanks-body" *ngIf="!showGoogleReviewLink()">
        We appreciate you taking the time to share your experience. Your feedback helps us improve
        our service.
      </p>
      <p class="thanks-body" *ngIf="showGoogleReviewLink()">
        We're glad it was good! Would you be willing to do the car wash a favor and leave a Google
        Review too?
      </p>
      <a
        class="google-review-link"
        *ngIf="showGoogleReviewLink()"
        href="#"
        (click)="openGoogleReview($event)"
      >
        Add Google Review
      </a>
      <button
        type="button"
        class="feedback-close"
        *ngIf="!closeBlocked()"
        (click)="closeFeedback()"
      >
        Close
      </button>
      <p class="close-hint" *ngIf="closeBlocked()">You can close this tab.</p>
    </div>

    <!-- Invalid link -->
    <div class="state-block" *ngIf="step() === 'invalid'">
      <h2 class="state-headline">Link no longer valid</h2>
      <p class="state-body">
        This feedback link is invalid or has expired. If you still want to share feedback, please
        contact {{ carWashName() || 'the car wash' }}.
      </p>
      <button
        type="button"
        class="feedback-close"
        *ngIf="!closeBlocked()"
        (click)="closeFeedback()"
      >
        Close
      </button>
      <p class="close-hint" *ngIf="closeBlocked()">You can close this tab.</p>
    </div>

    <!-- Already submitted -->
    <div class="state-block" *ngIf="step() === 'already_submitted'">
      <h2 class="state-headline">Already submitted</h2>
      <p class="state-body">You've already shared feedback for this visit. Thank you!</p>
      <button
        type="button"
        class="feedback-close"
        *ngIf="!closeBlocked()"
        (click)="closeFeedback()"
      >
        Close
      </button>
      <p class="close-hint" *ngIf="closeBlocked()">You can close this tab.</p>
    </div>
  </div>
</div>
